/* UI translation dictionaries (chrome + home + search + booking).
 * Long-form CONTENT (villa descriptions, blog, SEO text) is translated
 * separately via the admin AI-translation tools (Phase 3D-2). */

export const translations = {
  en: {
    nav: {
      villas: "Villas", areas: "Areas", collections: "Collections", guide: "Blog",
      about: "About", contact: "Contact", signIn: "Sign in", findVilla: "Find a Villa",
      myDashboard: "My Dashboard", ownerPortal: "Owner Portal", adminPanel: "Admin Panel", signOut: "Sign out", home: "Home",
    },
    lang: { label: "Language" },
    legal: {
      title: "Legal Information",
      company: "Company", taxId: "NIF / CIF", legalForm: "Legal form", regOffice: "Registered office",
      owner: "Owner", bank: "Bank transfer details", beneficiary: "Beneficiary",
      legalFormValue: "Sociedad Limitada (SL)",
    },
    bookingStatus: {
      nav: "My Booking",
      title: "Track Your Booking",
      subtitle: "Enter your booking reference and PIN to view your reservation status, invoice and voucher — no account needed.",
      reference: "Booking reference", refPlaceholder: "MLV-XXXXXX",
      pin: "PIN code", pinPlaceholder: "6-digit PIN",
      submit: "View my booking", searching: "Searching…",
      notFound: "No booking found with that reference and PIN. Please check and try again.",
      foundTitle: "Your Reservation", status: "Status", dates: "Dates", guests: "Guests", nights: "nights",
      total: "Estimated total", voucher: "Download voucher (PDF)",
      invoiceTitle: "Invoice", invoiceNumber: "Invoice no.", invoiceAmount: "Amount due",
      invoiceDownload: "Download invoice (PDF)",
      invoiceNone: "No invoice has been issued yet. Your manager will send one once your booking is confirmed.",
      another: "Look up another booking", managerNotes: "Manager notes",
      payTitle: "Payment", payNow: "Pay now", bankDetails: "Bank transfer details",
      statuses: { new: "Request received", confirmed: "Confirmed", invoiced: "Invoice sent", paid: "Paid", cancelled: "Cancelled", completed: "Completed" },
    },
    hero: {
      eyebrow: "Costa del Sol · Spain",
      title: "Marbella's Finest Luxury Villas",
      subtitle: "Handpicked private residences, a dedicated concierge, and a seamless booking experience the resorts can't match.",
    },
    stats: { villas: "Luxury Villas", areas: "Prime Areas", rating: "Guest Rating", guests: "Guests Hosted" },
    sections: {
      featuredEyebrow: "Curated Collection", featuredTitle: "Featured Villas", viewAll: "View all villas",
      mapEyebrow: "Explore the Coast", mapTitle: "The Marbella Map",
      mapSubtitle: "Discover our villas across Marbella's most coveted neighbourhoods. Tap a price pin to explore.",
      conciergeEyebrow: "Beyond the Villa", conciergeTitle: "Luxury Concierge Services",
      conciergeSubtitle: "From the moment you enquire to the day you depart, our concierge team curates every detail of your Marbella experience.",
      reviewsEyebrow: "Guest Stories", reviewsTitle: "Loved by Discerning Travellers",
      guideEyebrow: "Marbella Guide", guideTitle: "Explore the Neighbourhoods",
      blogEyebrow: "The Journal", blogTitle: "Stories & Guides", allArticles: "All articles",
      faqEyebrow: "Good to Know", faqTitle: "Frequently Asked Questions",
      faqSubtitle: "Everything you need to know about booking your luxury Marbella villa.",
    },
    services: {
      chefT: "Private Chefs", chefD: "Michelin-trained chefs crafting bespoke menus in your villa.",
      transferT: "Airport Transfers", transferD: "Chauffeured luxury cars from Málaga airport to your door.",
      yachtT: "Yacht Charters", yachtD: "Private superyacht days along the glittering Costa del Sol.",
      conciergeT: "24/7 Concierge", conciergeD: "A dedicated team to arrange every detail of your stay.",
    },
    cta: {
      title: "Your Marbella Escape Awaits",
      subtitle: "Let our concierge find your perfect villa. Submit a request and we'll handle the rest — personally.",
      browse: "Browse Villas", talk: "Talk to Concierge",
    },
    footer: {
      tagline: "The Costa del Sol's premier collection of luxury villa rentals. Handpicked residences, a dedicated concierge, and a booking experience beyond compare.",
      areas: "Areas", collections: "Collections", contact: "Contact", aboutUs: "About Us", guide: "Marbella Guide",
      rights: "All rights reserved.", legal: "Privacy · Terms · GDPR Compliant · Secure Booking",
    },
    card: { beds: "beds", perNight: "/ night", minNights: "Min {n} nights" },
    villa: {
      about: "About this villa", amenities: "Amenities & Features", location: "The Location",
      aboutArea: "About {area}", beaches: "Beaches nearby", dining: "Dining nearby",
      thingsToDo: "Things to do", houseRules: "House Rules", depositPolicy: "A refundable security deposit of €3,000 is required for every villa booking. It must be paid right after booking and is returned in full on your check-out day, provided there is no damage.", reviews: "Guest Reviews", registrationLabel: "Tourist registration no.",
      faq: "Frequently Asked Questions", videoTour: "Video & Aerial Tour", tourVideo: "Tour Video",
      droneAerial: "Drone Aerial", notFound: "Villa not found",
    },
    features: {
      pool: "Private Pool", heated_pool: "Heated Pool", sea_view: "Sea View", beachfront: "Beachfront",
      jacuzzi: "Jacuzzi", gym: "Gym", sauna: "Sauna", cinema_room: "Cinema Room", smart_home: "Smart Home",
      golf: "Golf", pet_friendly: "Pet Friendly", family_friendly: "Family Friendly", event_friendly: "Event Friendly",
    },
    search: {
      title: "Find Your Villa", subtitleCount: "{n} luxury villas across Marbella",
      aiPlaceholder: "Try AI search: 'villa for 12 with cinema room and sea view'", aiSearch: "AI Search",
      filters: "Filters", area: "Area", anyArea: "Any area", pricePerNight: "Price / night",
      guests: "Guests", beds: "Beds", baths: "Baths", any: "Any", amenities: "Amenities & Features",
      clearAll: "Clear all filters", sortRecommended: "Recommended", sortPriceAsc: "Price: Low to High",
      sortPriceDesc: "Price: High to Low", sortRating: "Top Rated",
      noMatch: "No villas match your filters", noMatchSub: "Try adjusting your criteria or clearing filters.",
      clearFilters: "Clear filters", guestsSuffix: "+ guests",
    },
    booking: {
      perNight: "/ night", minNights: "Min {n} nights", selectDates: "Select your dates",
      couponPlaceholder: "Coupon code", apply: "Apply", nights: "nights", discount: "Discount",
      estimatedTotal: "Estimated total", requestToBook: "Request to Book",
      noPaymentNow: "No payment now · Your manager confirms & invoices",
      requestTitle: "Request {villa}", firstName: "First name", lastName: "Last name",
      email: "Email address", phone: "Phone number", whatsappPlaceholder: "WhatsApp number (for instant updates)",
      tripMessage: "Tell us about your trip (optional)", confirmRequest: "Confirm Booking Request",
      agree: "By confirming you agree to be contacted by our concierge. No payment is taken now.",
      confirmed: "Booking Confirmed",
      thankYou: "Thank you, {name}. Your request for {villa} ({checkIn} → {checkOut}) is received.",
      ref: "Booking Ref", pin: "PIN Code",
      managerConfirm: "Your dedicated manager will confirm availability and send a secure invoice link or bank transfer (IBAN) details shortly.",
      downloadPdf: "Download Confirmation PDF", messageWhatsApp: "Message your manager on WhatsApp",
      close: "Close", createAccount: "Create Account",
      errDates: "Please select your dates", errMinStay: "Minimum stay is {n} nights",
      errContact: "Please provide your first name, last name and email", errSubmit: "Could not submit request",
      couponApplied: "Coupon applied: {pct}% off", couponInvalid: "Invalid or expired coupon",
    },
  },

  es: {
    nav: {
      villas: "Villas", areas: "Zonas", collections: "Colecciones", guide: "Blog",
      about: "Nosotros", contact: "Contacto", signIn: "Acceder", findVilla: "Buscar Villa",
      myDashboard: "Mi panel", ownerPortal: "Portal del propietario", adminPanel: "Panel de administración", signOut: "Salir", home: "Inicio",
    },
    lang: { label: "Idioma" },
    legal: {
      title: "Información legal",
      company: "Empresa", taxId: "NIF / CIF", legalForm: "Forma jurídica", regOffice: "Domicilio social",
      owner: "Titular", bank: "Datos para transferencia bancaria", beneficiary: "Beneficiario",
      legalFormValue: "Sociedad Limitada (SL)",
    },
    bookingStatus: {
      nav: "Mi reserva",
      title: "Consulta tu reserva",
      subtitle: "Introduce tu referencia de reserva y tu PIN para ver el estado, la factura y el bono — sin necesidad de cuenta.",
      reference: "Referencia de reserva", refPlaceholder: "MLV-XXXXXX",
      pin: "Código PIN", pinPlaceholder: "PIN de 6 dígitos",
      submit: "Ver mi reserva", searching: "Buscando…",
      notFound: "No se encontró ninguna reserva con esa referencia y PIN. Verifícalos e inténtalo de nuevo.",
      foundTitle: "Tu reserva", status: "Estado", dates: "Fechas", guests: "Huéspedes", nights: "noches",
      total: "Total estimado", voucher: "Descargar bono (PDF)",
      invoiceTitle: "Factura", invoiceNumber: "Nº de factura", invoiceAmount: "Importe a pagar",
      invoiceDownload: "Descargar factura (PDF)",
      invoiceNone: "Todavía no se ha emitido ninguna factura. Tu gestor la enviará cuando se confirme la reserva.",
      another: "Consultar otra reserva", managerNotes: "Notas del gestor",
      statuses: { new: "Solicitud recibida", confirmed: "Confirmada", invoiced: "Factura enviada", paid: "Pagada", cancelled: "Cancelada", completed: "Completada" },
    },
    hero: {
      eyebrow: "Costa del Sol · España",
      title: "Las mejores villas de lujo de Marbella",
      subtitle: "Residencias privadas seleccionadas, un conserje dedicado y una experiencia de reserva impecable que los hoteles no pueden igualar.",
    },
    stats: { villas: "Villas de lujo", areas: "Zonas exclusivas", rating: "Valoración", guests: "Huéspedes alojados" },
    sections: {
      featuredEyebrow: "Colección seleccionada", featuredTitle: "Villas destacadas", viewAll: "Ver todas las villas",
      mapEyebrow: "Explora la costa", mapTitle: "El mapa de Marbella",
      mapSubtitle: "Descubre nuestras villas en los barrios más codiciados de Marbella. Toca un precio para explorar.",
      conciergeEyebrow: "Más allá de la villa", conciergeTitle: "Servicios de conserjería de lujo",
      conciergeSubtitle: "Desde el momento en que consulta hasta el día de su partida, nuestro equipo cuida cada detalle de su experiencia en Marbella.",
      reviewsEyebrow: "Historias de huéspedes", reviewsTitle: "Preferida por viajeros exigentes",
      guideEyebrow: "Guía de Marbella", guideTitle: "Explora los barrios",
      blogEyebrow: "El diario", blogTitle: "Historias y guías", allArticles: "Todos los artículos",
      faqEyebrow: "Bueno saber", faqTitle: "Preguntas frecuentes",
      faqSubtitle: "Todo lo que necesita saber para reservar su villa de lujo en Marbella.",
    },
    services: {
      chefT: "Chefs privados", chefD: "Chefs con formación Michelin que crean menús a medida en su villa.",
      transferT: "Traslados al aeropuerto", transferD: "Coches de lujo con chófer desde el aeropuerto de Málaga hasta su puerta.",
      yachtT: "Alquiler de yates", yachtD: "Días privados en superyate por la deslumbrante Costa del Sol.",
      conciergeT: "Conserjería 24/7", conciergeD: "Un equipo dedicado para organizar cada detalle de su estancia.",
    },
    cta: {
      title: "Su escapada a Marbella le espera",
      subtitle: "Deje que nuestro conserje encuentre su villa perfecta. Envíe una solicitud y nos encargamos del resto, personalmente.",
      browse: "Ver villas", talk: "Hablar con conserjería",
    },
    footer: {
      tagline: "La colección de referencia de villas de lujo de la Costa del Sol. Residencias seleccionadas, un conserje dedicado y una experiencia de reserva incomparable.",
      areas: "Zonas", collections: "Colecciones", contact: "Contacto", aboutUs: "Nosotros", guide: "Guía de Marbella",
      rights: "Todos los derechos reservados.", legal: "Privacidad · Términos · Cumple el RGPD · Reserva segura",
    },
    card: { beds: "habit.", perNight: "/ noche", minNights: "Mín. {n} noches" },
    villa: {
      about: "Sobre esta villa", amenities: "Comodidades y características", location: "Ubicación",
      aboutArea: "Sobre {area}", beaches: "Playas cercanas", dining: "Restaurantes cercanos",
      thingsToDo: "Qué hacer", houseRules: "Normas de la casa", depositPolicy: "Para cada reserva de villa se requiere un depósito de seguridad reembolsable de 3.000 €. Debe abonarse inmediatamente después de la reserva y se devuelve íntegramente el día de la salida, siempre que no haya daños.", reviews: "Opiniones de huéspedes", registrationLabel: "N.º de registro turístico",
      faq: "Preguntas frecuentes", videoTour: "Vídeo y tour aéreo", tourVideo: "Vídeo",
      droneAerial: "Vista aérea", notFound: "Villa no encontrada",
    },
    features: {
      pool: "Piscina privada", heated_pool: "Piscina climatizada", sea_view: "Vistas al mar", beachfront: "Primera línea de playa",
      jacuzzi: "Jacuzzi", gym: "Gimnasio", sauna: "Sauna", cinema_room: "Sala de cine", smart_home: "Domótica",
      golf: "Golf", pet_friendly: "Admite mascotas", family_friendly: "Familiar", event_friendly: "Apta para eventos",
    },
    search: {
      title: "Encuentra tu villa", subtitleCount: "{n} villas de lujo en Marbella",
      aiPlaceholder: "Prueba la búsqueda con IA: 'villa para 12 con cine y vistas al mar'", aiSearch: "Búsqueda IA",
      filters: "Filtros", area: "Zona", anyArea: "Cualquier zona", pricePerNight: "Precio / noche",
      guests: "Huéspedes", beds: "Habit.", baths: "Baños", any: "Cualquiera", amenities: "Comodidades y características",
      clearAll: "Borrar todos los filtros", sortRecommended: "Recomendado", sortPriceAsc: "Precio: de menor a mayor",
      sortPriceDesc: "Precio: de mayor a menor", sortRating: "Mejor valoradas",
      noMatch: "Ninguna villa coincide con tus filtros", noMatchSub: "Prueba a ajustar los criterios o borrar los filtros.",
      clearFilters: "Borrar filtros", guestsSuffix: "+ huéspedes",
    },
    booking: {
      perNight: "/ noche", minNights: "Mín. {n} noches", selectDates: "Selecciona tus fechas",
      couponPlaceholder: "Código de cupón", apply: "Aplicar", nights: "noches", discount: "Descuento",
      estimatedTotal: "Total estimado", requestToBook: "Solicitar reserva",
      noPaymentNow: "Sin pago ahora · Tu gestor confirma y factura",
      requestTitle: "Solicitar {villa}", firstName: "Nombre", lastName: "Apellidos",
      email: "Correo electrónico", phone: "Teléfono", whatsappPlaceholder: "Número de WhatsApp (para avisos instantáneos)",
      tripMessage: "Cuéntanos sobre tu viaje (opcional)", confirmRequest: "Confirmar solicitud",
      agree: "Al confirmar, aceptas que nuestro conserje te contacte. No se cobra ningún pago ahora.",
      confirmed: "Reserva confirmada",
      thankYou: "Gracias, {name}. Tu solicitud para {villa} ({checkIn} → {checkOut}) se ha recibido.",
      ref: "Ref. reserva", pin: "Código PIN",
      managerConfirm: "Tu gestor dedicado confirmará la disponibilidad y te enviará en breve un enlace de factura seguro o los datos de transferencia (IBAN).",
      downloadPdf: "Descargar confirmación PDF", messageWhatsApp: "Escribe a tu gestor por WhatsApp",
      close: "Cerrar", createAccount: "Crear cuenta",
      errDates: "Por favor, selecciona tus fechas", errMinStay: "La estancia mínima es de {n} noches",
      errContact: "Indica tu nombre, apellidos y correo electrónico", errSubmit: "No se pudo enviar la solicitud",
      couponApplied: "Cupón aplicado: {pct}% de descuento", couponInvalid: "Cupón no válido o caducado",
    },
  },

  de: {
    nav: {
      villas: "Villen", areas: "Regionen", collections: "Kollektionen", guide: "Blog",
      about: "Über uns", contact: "Kontakt", signIn: "Anmelden", findVilla: "Villa finden",
      myDashboard: "Mein Bereich", ownerPortal: "Eigentümer-Portal", adminPanel: "Admin-Bereich", signOut: "Abmelden", home: "Startseite",
    },
    lang: { label: "Sprache" },
    legal: {
      title: "Rechtliche Informationen",
      company: "Unternehmen", taxId: "NIF / CIF", legalForm: "Rechtsform", regOffice: "Geschäftssitz",
      owner: "Inhaber", bank: "Bankverbindung für Überweisung", beneficiary: "Begünstigter",
      legalFormValue: "Sociedad Limitada (SL)",
    },
    bookingStatus: {
      nav: "Meine Buchung",
      title: "Buchung verfolgen",
      subtitle: "Geben Sie Ihre Buchungsreferenz und PIN ein, um Status, Rechnung und Gutschein einzusehen — ganz ohne Konto.",
      reference: "Buchungsreferenz", refPlaceholder: "MLV-XXXXXX",
      pin: "PIN-Code", pinPlaceholder: "6-stelliger PIN",
      submit: "Meine Buchung ansehen", searching: "Suche läuft…",
      notFound: "Keine Buchung mit dieser Referenz und PIN gefunden. Bitte überprüfen und erneut versuchen.",
      foundTitle: "Ihre Reservierung", status: "Status", dates: "Daten", guests: "Gäste", nights: "Nächte",
      total: "Geschätzter Gesamtpreis", voucher: "Gutschein herunterladen (PDF)",
      invoiceTitle: "Rechnung", invoiceNumber: "Rechnungsnr.", invoiceAmount: "Fälliger Betrag",
      invoiceDownload: "Rechnung herunterladen (PDF)",
      invoiceNone: "Es wurde noch keine Rechnung ausgestellt. Ihr Manager sendet sie, sobald die Buchung bestätigt ist.",
      another: "Andere Buchung suchen", managerNotes: "Anmerkungen des Managers",
      payTitle: "Zahlung", payNow: "Jetzt bezahlen", bankDetails: "Bankverbindung für Überweisung",
      statuses: { new: "Anfrage erhalten", confirmed: "Bestätigt", invoiced: "Rechnung gesendet", paid: "Bezahlt", cancelled: "Storniert", completed: "Abgeschlossen" },
    },
    hero: {
      eyebrow: "Costa del Sol · Spanien",
      title: "Marbellas exklusivste Luxusvillen",
      subtitle: "Handverlesene Privatresidenzen, ein persönlicher Concierge und ein nahtloses Buchungserlebnis, das kein Resort bietet.",
    },
    stats: { villas: "Luxusvillen", areas: "Top-Lagen", rating: "Gästebewertung", guests: "Betreute Gäste" },
    sections: {
      featuredEyebrow: "Kuratierte Auswahl", featuredTitle: "Empfohlene Villen", viewAll: "Alle Villen ansehen",
      mapEyebrow: "Die Küste entdecken", mapTitle: "Die Karte von Marbella",
      mapSubtitle: "Entdecken Sie unsere Villen in Marbellas begehrtesten Vierteln. Tippen Sie auf einen Preis, um zu erkunden.",
      conciergeEyebrow: "Mehr als nur die Villa", conciergeTitle: "Luxuriöse Concierge-Services",
      conciergeSubtitle: "Von der ersten Anfrage bis zur Abreise kümmert sich unser Concierge-Team um jedes Detail Ihres Marbella-Erlebnisses.",
      reviewsEyebrow: "Gästegeschichten", reviewsTitle: "Geschätzt von anspruchsvollen Reisenden",
      guideEyebrow: "Marbella-Guide", guideTitle: "Entdecken Sie die Viertel",
      blogEyebrow: "Das Journal", blogTitle: "Geschichten & Guides", allArticles: "Alle Artikel",
      faqEyebrow: "Gut zu wissen", faqTitle: "Häufige Fragen",
      faqSubtitle: "Alles, was Sie über die Buchung Ihrer Luxusvilla in Marbella wissen müssen.",
    },
    services: {
      chefT: "Privatköche", chefD: "Michelin-geschulte Köche kreieren maßgeschneiderte Menüs in Ihrer Villa.",
      transferT: "Flughafentransfers", transferD: "Luxuslimousinen mit Chauffeur vom Flughafen Málaga bis vor Ihre Tür.",
      yachtT: "Yachtcharter", yachtD: "Private Superyacht-Tage entlang der glitzernden Costa del Sol.",
      conciergeT: "24/7 Concierge", conciergeD: "Ein engagiertes Team für jedes Detail Ihres Aufenthalts.",
    },
    cta: {
      title: "Ihre Auszeit in Marbella wartet",
      subtitle: "Unser Concierge findet Ihre perfekte Villa. Senden Sie eine Anfrage – um den Rest kümmern wir uns persönlich.",
      browse: "Villen ansehen", talk: "Concierge kontaktieren",
    },
    footer: {
      tagline: "Die erste Adresse für Luxusvilla-Vermietungen an der Costa del Sol. Handverlesene Residenzen, ein persönlicher Concierge und ein unvergleichliches Buchungserlebnis.",
      areas: "Regionen", collections: "Kollektionen", contact: "Kontakt", aboutUs: "Über uns", guide: "Marbella-Guide",
      rights: "Alle Rechte vorbehalten.", legal: "Datenschutz · AGB · DSGVO-konform · Sichere Buchung",
    },
    card: { beds: "Schlafz.", perNight: "/ Nacht", minNights: "Min. {n} Nächte" },
    villa: {
      about: "Über diese Villa", amenities: "Ausstattung & Highlights", location: "Die Lage",
      aboutArea: "Über {area}", beaches: "Strände in der Nähe", dining: "Restaurants in der Nähe",
      thingsToDo: "Aktivitäten", houseRules: "Hausregeln", depositPolicy: "Für jede Villenbuchung ist eine erstattbare Kaution von 3.000 € erforderlich. Sie ist unmittelbar nach der Buchung zu zahlen und wird am Abreisetag vollständig zurückerstattet, sofern keine Schäden vorliegen.", reviews: "Gästebewertungen", registrationLabel: "Tourismus-Registriernr.",
      faq: "Häufige Fragen", videoTour: "Video & Luftaufnahme", tourVideo: "Tour-Video",
      droneAerial: "Drohnenaufnahme", notFound: "Villa nicht gefunden",
    },
    features: {
      pool: "Privatpool", heated_pool: "Beheizter Pool", sea_view: "Meerblick", beachfront: "Direkt am Strand",
      jacuzzi: "Whirlpool", gym: "Fitnessraum", sauna: "Sauna", cinema_room: "Heimkino", smart_home: "Smart Home",
      golf: "Golf", pet_friendly: "Haustierfreundlich", family_friendly: "Familienfreundlich", event_friendly: "Für Events geeignet",
    },
    search: {
      title: "Finden Sie Ihre Villa", subtitleCount: "{n} Luxusvillen in ganz Marbella",
      aiPlaceholder: "KI-Suche testen: 'Villa für 12 mit Kinosaal und Meerblick'", aiSearch: "KI-Suche",
      filters: "Filter", area: "Region", anyArea: "Beliebige Region", pricePerNight: "Preis / Nacht",
      guests: "Gäste", beds: "Schlafz.", baths: "Bäder", any: "Beliebig", amenities: "Ausstattung & Merkmale",
      clearAll: "Alle Filter zurücksetzen", sortRecommended: "Empfohlen", sortPriceAsc: "Preis: aufsteigend",
      sortPriceDesc: "Preis: absteigend", sortRating: "Top bewertet",
      noMatch: "Keine Villa entspricht Ihren Filtern", noMatchSub: "Passen Sie die Kriterien an oder setzen Sie die Filter zurück.",
      clearFilters: "Filter zurücksetzen", guestsSuffix: "+ Gäste",
    },
    booking: {
      perNight: "/ Nacht", minNights: "Min. {n} Nächte", selectDates: "Wählen Sie Ihre Daten",
      couponPlaceholder: "Gutscheincode", apply: "Anwenden", nights: "Nächte", discount: "Rabatt",
      estimatedTotal: "Geschätzte Summe", requestToBook: "Buchung anfragen",
      noPaymentNow: "Keine Zahlung jetzt · Ihr Manager bestätigt & stellt Rechnung",
      requestTitle: "{villa} anfragen", firstName: "Vorname", lastName: "Nachname",
      email: "E-Mail-Adresse", phone: "Telefonnummer", whatsappPlaceholder: "WhatsApp-Nummer (für sofortige Updates)",
      tripMessage: "Erzählen Sie uns von Ihrer Reise (optional)", confirmRequest: "Buchungsanfrage bestätigen",
      agree: "Mit der Bestätigung stimmen Sie zu, von unserem Concierge kontaktiert zu werden. Es wird jetzt keine Zahlung fällig.",
      confirmed: "Buchung bestätigt",
      thankYou: "Danke, {name}. Ihre Anfrage für {villa} ({checkIn} → {checkOut}) ist eingegangen.",
      ref: "Buchungsref.", pin: "PIN-Code",
      managerConfirm: "Ihr persönlicher Manager bestätigt die Verfügbarkeit und sendet Ihnen in Kürze einen sicheren Rechnungslink oder die Überweisungsdaten (IBAN).",
      downloadPdf: "Bestätigung als PDF", messageWhatsApp: "Manager via WhatsApp schreiben",
      close: "Schließen", createAccount: "Konto erstellen",
      errDates: "Bitte wählen Sie Ihre Daten", errMinStay: "Mindestaufenthalt beträgt {n} Nächte",
      errContact: "Bitte geben Sie Vorname, Nachname und E-Mail an", errSubmit: "Anfrage konnte nicht gesendet werden",
      couponApplied: "Gutschein angewendet: {pct}% Rabatt", couponInvalid: "Ungültiger oder abgelaufener Gutschein",
    },
  },

  fr: {
    nav: {
      villas: "Villas", areas: "Quartiers", collections: "Collections", guide: "Blog",
      about: "À propos", contact: "Contact", signIn: "Connexion", findVilla: "Trouver une villa",
      myDashboard: "Mon espace", ownerPortal: "Espace propriétaire", adminPanel: "Administration", signOut: "Déconnexion", home: "Accueil",
    },
    lang: { label: "Langue" },
    legal: {
      title: "Informations légales",
      company: "Société", taxId: "NIF / CIF", legalForm: "Forme juridique", regOffice: "Siège social",
      owner: "Titulaire", bank: "Coordonnées bancaires pour virement", beneficiary: "Bénéficiaire",
      legalFormValue: "Sociedad Limitada (SL)",
    },
    bookingStatus: {
      nav: "Ma réservation",
      title: "Suivre votre réservation",
      subtitle: "Saisissez votre référence de réservation et votre PIN pour voir le statut, la facture et le bon — sans compte.",
      reference: "Référence de réservation", refPlaceholder: "MLV-XXXXXX",
      pin: "Code PIN", pinPlaceholder: "PIN à 6 chiffres",
      submit: "Voir ma réservation", searching: "Recherche…",
      notFound: "Aucune réservation trouvée avec cette référence et ce PIN. Veuillez vérifier et réessayer.",
      foundTitle: "Votre réservation", status: "Statut", dates: "Dates", guests: "Voyageurs", nights: "nuits",
      total: "Total estimé", voucher: "Télécharger le bon (PDF)",
      invoiceTitle: "Facture", invoiceNumber: "Nº de facture", invoiceAmount: "Montant dû",
      invoiceDownload: "Télécharger la facture (PDF)",
      invoiceNone: "Aucune facture n'a encore été émise. Votre gestionnaire l'enverra dès la confirmation de la réservation.",
      another: "Rechercher une autre réservation", managerNotes: "Notes du gestionnaire",
      payTitle: "Paiement", payNow: "Payer maintenant", bankDetails: "Coordonnées bancaires pour virement",
      statuses: { new: "Demande reçue", confirmed: "Confirmée", invoiced: "Facture envoyée", paid: "Payée", cancelled: "Annulée", completed: "Terminée" },
    },
    hero: {
      eyebrow: "Costa del Sol · Espagne",
      title: "Les plus belles villas de luxe de Marbella",
      subtitle: "Des résidences privées triées sur le volet, un concierge dédié et une réservation fluide que les complexes hôteliers ne peuvent égaler.",
    },
    stats: { villas: "Villas de luxe", areas: "Quartiers prisés", rating: "Note des clients", guests: "Clients accueillis" },
    sections: {
      featuredEyebrow: "Collection sélectionnée", featuredTitle: "Villas à la une", viewAll: "Voir toutes les villas",
      mapEyebrow: "Explorez la côte", mapTitle: "La carte de Marbella",
      mapSubtitle: "Découvrez nos villas dans les quartiers les plus convoités de Marbella. Touchez un prix pour explorer.",
      conciergeEyebrow: "Au-delà de la villa", conciergeTitle: "Services de conciergerie de luxe",
      conciergeSubtitle: "De votre première demande au jour du départ, notre équipe de conciergerie orchestre chaque détail de votre séjour à Marbella.",
      reviewsEyebrow: "Témoignages", reviewsTitle: "Plébiscitée par les voyageurs exigeants",
      guideEyebrow: "Guide de Marbella", guideTitle: "Explorez les quartiers",
      blogEyebrow: "Le journal", blogTitle: "Récits & guides", allArticles: "Tous les articles",
      faqEyebrow: "Bon à savoir", faqTitle: "Questions fréquentes",
      faqSubtitle: "Tout ce qu'il faut savoir pour réserver votre villa de luxe à Marbella.",
    },
    services: {
      chefT: "Chefs privés", chefD: "Des chefs formés en étoiles Michelin créent des menus sur mesure dans votre villa.",
      transferT: "Transferts aéroport", transferD: "Voitures de luxe avec chauffeur de l'aéroport de Málaga jusqu'à votre porte.",
      yachtT: "Location de yachts", yachtD: "Journées privées en superyacht le long de la scintillante Costa del Sol.",
      conciergeT: "Conciergerie 24/7", conciergeD: "Une équipe dédiée pour organiser chaque détail de votre séjour.",
    },
    cta: {
      title: "Votre évasion à Marbella vous attend",
      subtitle: "Laissez notre concierge trouver votre villa idéale. Envoyez une demande, nous nous occupons du reste, personnellement.",
      browse: "Parcourir les villas", talk: "Parler au concierge",
    },
    footer: {
      tagline: "La référence des locations de villas de luxe de la Costa del Sol. Des résidences triées sur le volet, un concierge dédié et une expérience de réservation incomparable.",
      areas: "Quartiers", collections: "Collections", contact: "Contact", aboutUs: "À propos", guide: "Guide de Marbella",
      rights: "Tous droits réservés.", legal: "Confidentialité · Conditions · Conforme RGPD · Réservation sécurisée",
    },
    card: { beds: "ch.", perNight: "/ nuit", minNights: "Min. {n} nuits" },
    villa: {
      about: "À propos de cette villa", amenities: "Équipements et caractéristiques", location: "L'emplacement",
      aboutArea: "À propos de {area}", beaches: "Plages à proximité", dining: "Restaurants à proximité",
      thingsToDo: "À faire", houseRules: "Règlement intérieur", depositPolicy: "Une caution remboursable de 3 000 € est exigée pour chaque réservation de villa. Elle doit être réglée immédiatement après la réservation et est intégralement restituée le jour du départ, en l'absence de dommages.", reviews: "Avis des clients", registrationLabel: "N° d'enregistrement touristique",
      faq: "Questions fréquentes", videoTour: "Vidéo et vue aérienne", tourVideo: "Vidéo",
      droneAerial: "Vue aérienne", notFound: "Villa introuvable",
    },
    features: {
      pool: "Piscine privée", heated_pool: "Piscine chauffée", sea_view: "Vue mer", beachfront: "Front de mer",
      jacuzzi: "Jacuzzi", gym: "Salle de sport", sauna: "Sauna", cinema_room: "Salle de cinéma", smart_home: "Maison connectée",
      golf: "Golf", pet_friendly: "Animaux admis", family_friendly: "Familial", event_friendly: "Adaptée aux événements",
    },
    search: {
      title: "Trouvez votre villa", subtitleCount: "{n} villas de luxe à Marbella",
      aiPlaceholder: "Essayez la recherche IA : 'villa pour 12 avec salle de cinéma et vue mer'", aiSearch: "Recherche IA",
      filters: "Filtres", area: "Quartier", anyArea: "Tous les quartiers", pricePerNight: "Prix / nuit",
      guests: "Voyageurs", beds: "Ch.", baths: "SdB", any: "Tous", amenities: "Équipements et caractéristiques",
      clearAll: "Effacer tous les filtres", sortRecommended: "Recommandé", sortPriceAsc: "Prix : croissant",
      sortPriceDesc: "Prix : décroissant", sortRating: "Les mieux notées",
      noMatch: "Aucune villa ne correspond à vos filtres", noMatchSub: "Ajustez vos critères ou effacez les filtres.",
      clearFilters: "Effacer les filtres", guestsSuffix: "+ voyageurs",
    },
    booking: {
      perNight: "/ nuit", minNights: "Min. {n} nuits", selectDates: "Sélectionnez vos dates",
      couponPlaceholder: "Code promo", apply: "Appliquer", nights: "nuits", discount: "Remise",
      estimatedTotal: "Total estimé", requestToBook: "Demander à réserver",
      noPaymentNow: "Aucun paiement maintenant · Votre gestionnaire confirme et facture",
      requestTitle: "Demander {villa}", firstName: "Prénom", lastName: "Nom",
      email: "Adresse e-mail", phone: "Numéro de téléphone", whatsappPlaceholder: "Numéro WhatsApp (pour des mises à jour instantanées)",
      tripMessage: "Parlez-nous de votre voyage (facultatif)", confirmRequest: "Confirmer la demande",
      agree: "En confirmant, vous acceptez d'être contacté par notre concierge. Aucun paiement n'est prélevé maintenant.",
      confirmed: "Réservation confirmée",
      thankYou: "Merci, {name}. Votre demande pour {villa} ({checkIn} → {checkOut}) a bien été reçue.",
      ref: "Réf. réservation", pin: "Code PIN",
      managerConfirm: "Votre gestionnaire dédié confirmera la disponibilité et vous enverra sous peu un lien de facture sécurisé ou les coordonnées bancaires (IBAN).",
      downloadPdf: "Télécharger la confirmation PDF", messageWhatsApp: "Écrire à votre gestionnaire sur WhatsApp",
      close: "Fermer", createAccount: "Créer un compte",
      errDates: "Veuillez sélectionner vos dates", errMinStay: "Le séjour minimum est de {n} nuits",
      errContact: "Veuillez indiquer vos prénom, nom et e-mail", errSubmit: "Impossible d'envoyer la demande",
      couponApplied: "Code appliqué : {pct}% de remise", couponInvalid: "Code promo invalide ou expiré",
    },
  },

  uk: {
    nav: {
      villas: "Вілли", areas: "Райони", collections: "Колекції", guide: "Блог",
      about: "Про нас", contact: "Контакти", signIn: "Увійти", findVilla: "Знайти віллу",
      myDashboard: "Мій кабінет", ownerPortal: "Портал власника", adminPanel: "Адмінпанель", signOut: "Вийти", home: "Головна",
    },
    lang: { label: "Мова" },
    legal: {
      title: "Юридична інформація",
      company: "Компанія", taxId: "NIF / CIF", legalForm: "Юридична форма", regOffice: "Юридична адреса",
      owner: "Власник", bank: "Реквізити для банківського переказу", beneficiary: "Отримувач",
      legalFormValue: "Sociedad Limitada (SL)",
    },
    bookingStatus: {
      nav: "Моє бронювання",
      title: "Відстежити бронювання",
      subtitle: "Введіть номер бронювання та PIN, щоб переглянути статус, рахунок і ваучер — без реєстрації.",
      reference: "Номер бронювання", refPlaceholder: "MLV-XXXXXX",
      pin: "PIN-код", pinPlaceholder: "6-значний PIN",
      submit: "Переглянути бронювання", searching: "Пошук…",
      notFound: "Бронювання з таким номером і PIN не знайдено. Перевірте дані та спробуйте ще раз.",
      foundTitle: "Ваше бронювання", status: "Статус", dates: "Дати", guests: "Гості", nights: "ночей",
      total: "Орієнтовна сума", voucher: "Завантажити ваучер (PDF)",
      invoiceTitle: "Рахунок", invoiceNumber: "Номер рахунку", invoiceAmount: "Сума до сплати",
      invoiceDownload: "Завантажити рахунок (PDF)",
      invoiceNone: "Рахунок ще не виставлено. Ваш менеджер надішле його після підтвердження бронювання.",
      another: "Знайти інше бронювання", managerNotes: "Примітки менеджера",
      payTitle: "Оплата", payNow: "Сплатити зараз", bankDetails: "Реквізити для банківського переказу",
      statuses: { new: "Заявку отримано", confirmed: "Підтверджено", invoiced: "Рахунок надіслано", paid: "Сплачено", cancelled: "Скасовано", completed: "Завершено" },
    },
    hero: {
      eyebrow: "Коста-дель-Соль · Іспанія",
      title: "Найкращі люксові вілли Марбельї",
      subtitle: "Ретельно відібрані приватні резиденції, персональний консьєрж і бездоганний процес бронювання, якого не пропонують готелі.",
    },
    stats: { villas: "Люксові вілли", areas: "Престижні райони", rating: "Оцінка гостей", guests: "Прийнятих гостей" },
    sections: {
      featuredEyebrow: "Добірна колекція", featuredTitle: "Рекомендовані вілли", viewAll: "Усі вілли",
      mapEyebrow: "Досліджуйте узбережжя", mapTitle: "Карта Марбельї",
      mapSubtitle: "Відкрийте наші вілли в найбажаніших районах Марбельї. Торкніться ціни, щоб переглянути.",
      conciergeEyebrow: "Більше, ніж вілла", conciergeTitle: "Люксові послуги консьєржа",
      conciergeSubtitle: "Від першого запиту до дня від'їзду наша команда консьєржів дбає про кожну деталь вашого відпочинку в Марбельї.",
      reviewsEyebrow: "Історії гостей", reviewsTitle: "Обирають вимогливі мандрівники",
      guideEyebrow: "Гід Марбельї", guideTitle: "Досліджуйте райони",
      blogEyebrow: "Журнал", blogTitle: "Історії та гіди", allArticles: "Усі статті",
      faqEyebrow: "Корисно знати", faqTitle: "Поширені запитання",
      faqSubtitle: "Усе, що потрібно знати про бронювання вашої люксової вілли в Марбельї.",
    },
    services: {
      chefT: "Приватні шеф-кухарі", chefD: "Шеф-кухарі рівня Michelin готують меню на замовлення у вашій віллі.",
      transferT: "Трансфери з аеропорту", transferD: "Люксові авто з водієм від аеропорту Малаги до ваших дверей.",
      yachtT: "Оренда яхт", yachtD: "Приватні дні на суперяхті уздовж сяючого узбережжя Коста-дель-Соль.",
      conciergeT: "Консьєрж 24/7", conciergeD: "Віддана команда організує кожну деталь вашого перебування.",
    },
    cta: {
      title: "Ваша відпустка в Марбельї чекає",
      subtitle: "Дозвольте нашому консьєржу знайти ідеальну віллу. Надішліть запит — решту ми зробимо особисто.",
      browse: "Переглянути вілли", talk: "Зв'язатися з консьєржем",
    },
    footer: {
      tagline: "Провідна колекція оренди люксових вілл на Коста-дель-Соль. Відібрані резиденції, персональний консьєрж і неперевершений досвід бронювання.",
      areas: "Райони", collections: "Колекції", contact: "Контакти", aboutUs: "Про нас", guide: "Гід Марбельї",
      rights: "Усі права захищено.", legal: "Конфіденційність · Умови · Відповідає GDPR · Безпечне бронювання",
    },
    card: { beds: "спальні", perNight: "/ ніч", minNights: "Мін. {n} ночей" },
    villa: {
      about: "Про цю віллу", amenities: "Зручності та особливості", location: "Розташування",
      aboutArea: "Про {area}", beaches: "Пляжі поруч", dining: "Ресторани поруч",
      thingsToDo: "Чим зайнятися", houseRules: "Правила проживання", depositPolicy: "Для кожного бронювання вілли потрібен поворотний завдаток 3 000 €. Його потрібно сплатити одразу після бронювання, і він повертається в повному обсязі в день виїзду за умови відсутності пошкоджень.", reviews: "Відгуки гостей", registrationLabel: "Реєстраційний номер туристичного житла",
      faq: "Поширені запитання", videoTour: "Відео та аерозйомка", tourVideo: "Відео",
      droneAerial: "Аерозйомка", notFound: "Віллу не знайдено",
    },
    features: {
      pool: "Приватний басейн", heated_pool: "Підігрів басейну", sea_view: "Вид на море", beachfront: "Перша лінія пляжу",
      jacuzzi: "Джакузі", gym: "Спортзал", sauna: "Сауна", cinema_room: "Кінозал", smart_home: "Розумний дім",
      golf: "Гольф", pet_friendly: "Можна з тваринами", family_friendly: "Для сімей", event_friendly: "Для заходів",
    },
    search: {
      title: "Знайдіть свою віллу", subtitleCount: "{n} люксових вілл у Марбельї",
      aiPlaceholder: "Спробуйте AI-пошук: 'вілла на 12 з кінозалом і видом на море'", aiSearch: "AI-пошук",
      filters: "Фільтри", area: "Район", anyArea: "Будь-який район", pricePerNight: "Ціна / ніч",
      guests: "Гості", beds: "Спальні", baths: "Ванні", any: "Будь-яка", amenities: "Зручності та особливості",
      clearAll: "Очистити всі фільтри", sortRecommended: "Рекомендовані", sortPriceAsc: "Ціна: за зростанням",
      sortPriceDesc: "Ціна: за спаданням", sortRating: "Найвищий рейтинг",
      noMatch: "Жодна вілла не відповідає фільтрам", noMatchSub: "Спробуйте змінити критерії або очистити фільтри.",
      clearFilters: "Очистити фільтри", guestsSuffix: "+ гостей",
    },
    booking: {
      perNight: "/ ніч", minNights: "Мін. {n} ночей", selectDates: "Оберіть дати",
      couponPlaceholder: "Промокод", apply: "Застосувати", nights: "ночей", discount: "Знижка",
      estimatedTotal: "Орієнтовна сума", requestToBook: "Запит на бронювання",
      noPaymentNow: "Без оплати зараз · Менеджер підтвердить і виставить рахунок",
      requestTitle: "Запит на {villa}", firstName: "Ім'я", lastName: "Прізвище",
      email: "Електронна пошта", phone: "Номер телефону", whatsappPlaceholder: "Номер WhatsApp (для миттєвих сповіщень)",
      tripMessage: "Розкажіть про вашу подорож (необов'язково)", confirmRequest: "Підтвердити запит",
      agree: "Підтверджуючи, ви погоджуєтесь, що наш консьєрж зв'яжеться з вами. Жодної оплати зараз не стягується.",
      confirmed: "Бронювання підтверджено",
      thankYou: "Дякуємо, {name}. Ваш запит на {villa} ({checkIn} → {checkOut}) отримано.",
      ref: "Номер броні", pin: "PIN-код",
      managerConfirm: "Ваш персональний менеджер підтвердить наявність і незабаром надішле безпечне посилання на рахунок або реквізити для переказу (IBAN).",
      downloadPdf: "Завантажити підтвердження PDF", messageWhatsApp: "Написати менеджеру у WhatsApp",
      close: "Закрити", createAccount: "Створити акаунт",
      errDates: "Будь ласка, оберіть дати", errMinStay: "Мінімальне перебування — {n} ночей",
      errContact: "Вкажіть ім'я, прізвище та електронну пошту", errSubmit: "Не вдалося надіслати запит",
      couponApplied: "Промокод застосовано: знижка {pct}%", couponInvalid: "Недійсний або прострочений промокод",
    },
  },

  ru: {
    nav: {
      villas: "Виллы", areas: "Районы", collections: "Коллекции", guide: "Блог",
      about: "О нас", contact: "Контакты", signIn: "Войти", findVilla: "Найти виллу",
      myDashboard: "Мой кабинет", ownerPortal: "Портал владельца", adminPanel: "Админпанель", signOut: "Выйти", home: "Главная",
    },
    lang: { label: "Язык" },
    legal: {
      title: "Юридическая информация",
      company: "Компания", taxId: "NIF / CIF", legalForm: "Юридическая форма", regOffice: "Юридический адрес",
      owner: "Владелец", bank: "Реквизиты для банковского перевода", beneficiary: "Получатель",
      legalFormValue: "Sociedad Limitada (SL)",
    },
    bookingStatus: {
      nav: "Моё бронирование",
      title: "Отследить бронирование",
      subtitle: "Введите номер бронирования и PIN, чтобы увидеть статус, счёт и ваучер — без регистрации.",
      reference: "Номер бронирования", refPlaceholder: "MLV-XXXXXX",
      pin: "PIN-код", pinPlaceholder: "6-значный PIN",
      submit: "Посмотреть бронирование", searching: "Поиск…",
      notFound: "Бронирование с таким номером и PIN не найдено. Проверьте данные и попробуйте снова.",
      foundTitle: "Ваше бронирование", status: "Статус", dates: "Даты", guests: "Гости", nights: "ночей",
      total: "Ориентировочная сумма", voucher: "Скачать ваучер (PDF)",
      invoiceTitle: "Счёт", invoiceNumber: "Номер счёта", invoiceAmount: "Сумма к оплате",
      invoiceDownload: "Скачать счёт (PDF)",
      invoiceNone: "Счёт ещё не выставлен. Менеджер пришлёт его после подтверждения бронирования.",
      another: "Найти другое бронирование", managerNotes: "Заметки менеджера",
      payTitle: "Оплата", payNow: "Оплатить сейчас", bankDetails: "Реквизиты для банковского перевода",
      statuses: { new: "Заявка получена", confirmed: "Подтверждено", invoiced: "Счёт отправлен", paid: "Оплачено", cancelled: "Отменено", completed: "Завершено" },
    },
    hero: {
      eyebrow: "Коста-дель-Соль · Испания",
      title: "Лучшие люксовые виллы Марбельи",
      subtitle: "Тщательно отобранные частные резиденции, персональный консьерж и безупречный процесс бронирования, недоступный отелям.",
    },
    stats: { villas: "Люксовые виллы", areas: "Престижные районы", rating: "Оценка гостей", guests: "Принятых гостей" },
    sections: {
      featuredEyebrow: "Кураторская подборка", featuredTitle: "Избранные виллы", viewAll: "Все виллы",
      mapEyebrow: "Исследуйте побережье", mapTitle: "Карта Марбельи",
      mapSubtitle: "Откройте наши виллы в самых желанных районах Марбельи. Нажмите на цену, чтобы посмотреть.",
      conciergeEyebrow: "Больше, чем вилла", conciergeTitle: "Люксовые услуги консьержа",
      conciergeSubtitle: "От первого запроса до дня отъезда наша команда консьержей продумывает каждую деталь вашего отдыха в Марбелье.",
      reviewsEyebrow: "Истории гостей", reviewsTitle: "Выбор взыскательных путешественников",
      guideEyebrow: "Гид по Марбелье", guideTitle: "Исследуйте районы",
      blogEyebrow: "Журнал", blogTitle: "Истории и гиды", allArticles: "Все статьи",
      faqEyebrow: "Полезно знать", faqTitle: "Частые вопросы",
      faqSubtitle: "Всё, что нужно знать о бронировании вашей люксовой виллы в Марбелье.",
    },
    services: {
      chefT: "Личные шеф-повара", chefD: "Шеф-повара уровня Michelin создают меню на заказ на вашей вилле.",
      transferT: "Трансферы из аэропорта", transferD: "Люксовые авто с водителем от аэропорта Малаги до ваших дверей.",
      yachtT: "Аренда яхт", yachtD: "Частные дни на суперъяхте вдоль сияющего побережья Коста-дель-Соль.",
      conciergeT: "Консьерж 24/7", conciergeD: "Преданная команда организует каждую деталь вашего пребывания.",
    },
    cta: {
      title: "Ваш отдых в Марбелье уже ждёт",
      subtitle: "Доверьте подбор идеальной виллы нашему консьержу. Отправьте запрос — остальное мы сделаем лично.",
      browse: "Смотреть виллы", talk: "Связаться с консьержем",
    },
    footer: {
      tagline: "Ведущая коллекция аренды люксовых вилл на Коста-дель-Соль. Отобранные резиденции, персональный консьерж и непревзойдённый опыт бронирования.",
      areas: "Районы", collections: "Коллекции", contact: "Контакты", aboutUs: "О нас", guide: "Гид по Марбелье",
      rights: "Все права защищены.", legal: "Конфиденциальность · Условия · Соответствует GDPR · Безопасное бронирование",
    },
    card: { beds: "спален", perNight: "/ ночь", minNights: "Мин. {n} ночей" },
    villa: {
      about: "Об этой вилле", amenities: "Удобства и особенности", location: "Расположение",
      aboutArea: "О районе {area}", beaches: "Пляжи поблизости", dining: "Рестораны поблизости",
      thingsToDo: "Чем заняться", houseRules: "Правила дома", depositPolicy: "Для каждого бронирования виллы требуется возвращаемый залог 3 000 €. Его нужно оплатить сразу после бронирования, и он возвращается в полном объёме в день выселения при отсутствии повреждений.", reviews: "Отзывы гостей", registrationLabel: "Регистрационный номер туристического жилья",
      faq: "Частые вопросы", videoTour: "Видео и аэросъёмка", tourVideo: "Видео",
      droneAerial: "Аэросъёмка", notFound: "Вилла не найдена",
    },
    features: {
      pool: "Частный бассейн", heated_pool: "Подогрев бассейна", sea_view: "Вид на море", beachfront: "Первая линия пляжа",
      jacuzzi: "Джакузи", gym: "Тренажёрный зал", sauna: "Сауна", cinema_room: "Кинозал", smart_home: "Умный дом",
      golf: "Гольф", pet_friendly: "Можно с питомцами", family_friendly: "Для семей", event_friendly: "Для мероприятий",
    },
    search: {
      title: "Найдите свою виллу", subtitleCount: "{n} люксовых вилл по всей Марбелье",
      aiPlaceholder: "Попробуйте AI-поиск: 'вилла на 12 с кинозалом и видом на море'", aiSearch: "AI-поиск",
      filters: "Фильтры", area: "Район", anyArea: "Любой район", pricePerNight: "Цена / ночь",
      guests: "Гости", beds: "Спальни", baths: "Ванные", any: "Любая", amenities: "Удобства и особенности",
      clearAll: "Сбросить все фильтры", sortRecommended: "Рекомендуемые", sortPriceAsc: "Цена: по возрастанию",
      sortPriceDesc: "Цена: по убыванию", sortRating: "Высокий рейтинг",
      noMatch: "Нет вилл по вашим фильтрам", noMatchSub: "Измените критерии или сбросьте фильтры.",
      clearFilters: "Сбросить фильтры", guestsSuffix: "+ гостей",
    },
    booking: {
      perNight: "/ ночь", minNights: "Мин. {n} ночей", selectDates: "Выберите даты",
      couponPlaceholder: "Промокод", apply: "Применить", nights: "ночей", discount: "Скидка",
      estimatedTotal: "Ориентировочная сумма", requestToBook: "Запрос на бронь",
      noPaymentNow: "Без оплаты сейчас · Менеджер подтвердит и выставит счёт",
      requestTitle: "Запрос на {villa}", firstName: "Имя", lastName: "Фамилия",
      email: "Электронная почта", phone: "Номер телефона", whatsappPlaceholder: "Номер WhatsApp (для мгновенных уведомлений)",
      tripMessage: "Расскажите о вашей поездке (необязательно)", confirmRequest: "Подтвердить запрос",
      agree: "Подтверждая, вы соглашаетесь, что наш консьерж свяжется с вами. Оплата сейчас не взимается.",
      confirmed: "Бронирование подтверждено",
      thankYou: "Спасибо, {name}. Ваш запрос на {villa} ({checkIn} → {checkOut}) получен.",
      ref: "Номер брони", pin: "PIN-код",
      managerConfirm: "Ваш персональный менеджер подтвердит доступность и вскоре пришлёт защищённую ссылку на счёт или реквизиты для перевода (IBAN).",
      downloadPdf: "Скачать подтверждение PDF", messageWhatsApp: "Написать менеджеру в WhatsApp",
      close: "Закрыть", createAccount: "Создать аккаунт",
      errDates: "Пожалуйста, выберите даты", errMinStay: "Минимальное проживание — {n} ночей",
      errContact: "Укажите имя, фамилию и электронную почту", errSubmit: "Не удалось отправить запрос",
      couponApplied: "Промокод применён: скидка {pct}%", couponInvalid: "Недействительный или истёкший промокод",
    },
  },
};
